import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../shared/services/auth/auth.service';
import { browserNavigation } from '../../shared/utils/browser-navigation.util';
import { decideImpersonationHandoff } from '../../shared/utils/impersonation-handoff.util';
import { ImpersonationEnvironment } from '../../shared/utils/impersonation-target.util';
import { clearSessionHandoff, readSessionHandoff } from '../../shared/utils/session-handoff.util';

@Component({
  selector: 'l-impersonation-entry',
  standalone: true,
  template: '',
})
export class ImpersonationEntryComponent implements OnInit {

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly authService: AuthService,
  ) {}

  public async ngOnInit(): Promise<void> {
    const current = this.route.snapshot.data['impersonationEnvironment'] as ImpersonationEnvironment;
    const decision = decideImpersonationHandoff(readSessionHandoff(), current);
    clearSessionHandoff();

    if (decision.type === 'redirect') {
      browserNavigation.assign(decision.url);
      return;
    }

    if (decision.type === 'reject') {
      await this.router.navigateByUrl('/login', { replaceUrl: true });
      return;
    }

    try {
      await this.authService.acceptImpersonation(decision.token);
      await this.router.navigateByUrl(environment.configs.authenticatedRoute, { replaceUrl: true });
    } catch {
      await this.authService.logout();
    }
  }

}
